import React from 'react';
import { FlaskConical, Sparkles, Wand2, Zap } from 'lucide-react';
type LabFeature = {
  id: number;
  name: string;
  description: string;
  icon: React.ReactNode;
  status: 'available' | 'coming-soon';
};
const labFeatures: LabFeature[] = [{
  id: 1,
  name: 'AI Voice Cloning',
  description: "Read storybooks in the storyteller's voice using AI voice cloning technology.",
  icon: <Wand2 className="w-6 h-6" data-id="element-1213" />,
  status: 'coming-soon'
}, {
  id: 2,
  name: 'Auto-Chapters',
  description: 'Automatically detect and create chapter breaks in longer recordings.',
  icon: <Sparkles className="w-6 h-6" data-id="element-1214" />,
  status: 'coming-soon'
}, {
  id: 3,
  name: 'Story Translation',
  description: 'Translate your storybooks into multiple languages to share with family worldwide.',
  icon: <Zap className="w-6 h-6" data-id="element-1215" />,
  status: 'coming-soon'
}];
export function LabsPage() {
  return <div className="flex-1 bg-gray-100 min-h-screen" data-id="element-1216">
      <div className="px-8 py-6" data-id="element-1217">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6" data-id="element-1218">
          <div className="p-2 bg-purple-100 rounded-lg" data-id="element-1219">
            <FlaskConical className="w-6 h-6 text-purple-600" data-id="element-1220" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-1221">Labs</h1>
        </div>

        <p className="text-gray-600 mb-8" data-id="element-1222">
          Experimental features and upcoming innovations. Try out new
          capabilities before they're released.
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1223">
          {labFeatures.map(feature => <div key={feature.id} className="bg-white rounded-2xl shadow-sm p-6 hover:shadow-md transition-shadow" data-id="element-1224">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-4 text-purple-600" data-id="element-1225">
                {feature.icon}
              </div>

              <div className="flex items-center justify-between mb-2" data-id="element-1226">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-1227">
                  {feature.name}
                </h3>
                {feature.status === 'coming-soon' && <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded" data-id="element-1228">
                    Coming Soon
                  </span>}
              </div>

              <p className="text-gray-600 text-sm mb-4" data-id="element-1229">
                {feature.description}
              </p>

              <button disabled={feature.status === 'coming-soon'} className={`w-full py-2 rounded-lg font-medium transition-colors ${feature.status === 'coming-soon' ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-purple-500 text-white hover:bg-purple-600'}`} data-id="element-1230">
                {feature.status === 'coming-soon' ? 'Coming Soon' : 'Try Now'}
              </button>
            </div>)}
        </div>

        {/* Info Box */}
        <div className="mt-8 p-6 bg-purple-50 rounded-xl border border-purple-200" data-id="element-1231">
          <h3 className="font-semibold text-purple-900 mb-2" data-id="element-1232">About Labs</h3>
          <p className="text-purple-800 text-sm" data-id="element-1233">
            Labs features are experimental and may change or be discontinued.
            We'd love your feedback as we develop these new capabilities!
          </p>
        </div>
      </div>
    </div>;
}